import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import theme from 'library/theme/theme';
import styled from 'styled-components';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

export const Expandable = styled((props: ExpandMoreProps) => {
  const { expand: _, ...other } = props;
  return <IconButton {...other} />;
})(({ expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));
